/**
 * Adaptador do Instagram Direct para o shell compartilhado do inbox.
 * Tudo que era fiacao do canal no antigo pages/instagram/* mora aqui.
 */
import { Instagram, Image, Video } from 'lucide-react';
import instagramService from '../../../services/instagram/instagramService';
import InstagramConnectionModal from '../../instagram/InstagramConnectionModal';
import { publishInstagramStatus } from '../../NavSidebar';
import { loadInstagramMessages } from '../../../services/inbox/chatMessageLoaders';

// Só image/audio/video existem no Direct; documento é recusado com aviso.
const IG_ALLOWED_TYPES = ['image', 'audio', 'video'];

const instagramAdapter = {
  code: 'instagram',
  label: 'Instagram',
  prefix: 'instagram:',
  keyField: 'contact_igsid',
  shortKey: 'igsid',
  route: '/instagram',
  Icon: Instagram,
  color: '#c13584',
  service: instagramService,
  loadMessages: (chatId) => loadInstagramMessages(chatId),
  normalizeMediaType: (t) => (IG_ALLOWED_TYPES.includes(t) ? t : null),
  allowDocument: false,
  allowAudio: true,
  windowed: true,
  hasHandle: true,
  sendMedia: (chat, url, type) => instagramService.sendMedia(chat.contact_igsid, url, type),
  handoffDismissKey: 'handoffDismissedIG',
  ConnectionModal: InstagramConnectionModal,
  publishStatus: publishInstagramStatus,
  oauth: {
    stateKey: 'ig_oauth_state',
    twoStep: false,
    cancelledText: 'Autorização cancelada ou recusada no Instagram.',
    exchangingText: 'Conectando sua conta do Instagram...',
  },
  // Eventos sociais no preview da lista (share, mencao em story, reel).
  mediaPreview: {
    share: { Icon: Image, label: 'Publicação' },
    story_mention: { Icon: Image, label: 'Menção em story' },
    ig_reel: { Icon: Video, label: 'Reel' },
  },
  headerStatus: (chat) => instagramService.getHandle(chat) || 'Instagram',
  texts: {
    searchPlaceholder: 'Pesquisar por nome ou @usuário',
    searchHint: 'Tente buscar por outro nome ou @usuário',
    previewFallback: (chat) => instagramService.getHandle(chat) || null,
    emptyHint: (account) => `As conversas aparecem aqui quando alguém enviar uma mensagem${account?.username ? ` para @${account.username}` : ''}. No Instagram a empresa não pode iniciar a conversa.`,
    placeholderHint: 'No Instagram a conversa começa sempre pelo cliente. Você tem 24 horas para responder cada mensagem recebida.',
    noAccount: 'Nenhuma conta do Instagram conectada',
    connectButton: 'Conectar Instagram',
    closedNotice: (name) => `A janela de 24 horas do Instagram fechou. Só é possível responder depois que ${name} enviar uma nova mensagem — o Instagram não permite retomar a conversa por iniciativa da empresa.`,
    mediaRejected: 'O Instagram só aceita imagem, áudio ou vídeo — anexos de documento foram ignorados.',
  },
};

export default instagramAdapter;
